<template>
  <div class="text-center" id="app">
  <h1><img src=../logo.jpg></h1>

  <TranslateForm v-on:formSubmit="translateText"></TranslateForm>
  <TranslateOutput v-text="translatedText"></TranslateOutput>

  <h4 style= "color:purple; position:absolute; bottom:0; left:45%;">Made with <i class="fa fa-code animated flash" aria-hidden="true" id="code"></i> and Vue.js</h4>

  </div>
</template>

<script>
import  TranslateForm from './components/TranslateForm'
import TranslateOutput from './components/TranslateOutput'

export default {
  name: 'app',
  components:{
    TranslateForm,
    TranslateOutput
  },
  data:function(){
    return {
      translatedText:''
    }
  },
  methods:{
    translateText:function(text,language){
      this.$http.get('https://translate.yandex.net/api/v1.5/tr.json/translate?key=trnsl.1.1.20170629T113143Z.6dcd1841be276fa2.4f7bd4b8c474d1b7125bdecf127d8f0951b7be64&lang='+language+'&text='+text)
      .then((response)=>{
        this.translatedText=response.body.text[0];
      });
    }
  }
}

</script>

<style>
#code {
  animation-iteration-count: infinite;
  animation-duration: 2s;
}
body{
  background:#fefefe;
}
</style>



// WEBPACK FOOTER //
// App.vue?4bc5c6e8